import React from "react";
import { SectionHeading } from "../../atom/SectionHeading";
import { ToggleButton } from "../../atom/ToggleButton";
import { useTranslation } from "react-i18next";
import { CornerUser } from "../../atom/CornerUser";
import { ExamsFilter } from "../../../types/components";
import { useUserContext } from "../../../utils/contexts/UserProvider";

interface ExamsHeadingProps {
  filter: ExamsFilter;
  setFilter: React.Dispatch<React.SetStateAction<ExamsFilter>>;
}

export const ExamsHeading: React.FC<ExamsHeadingProps> = ({ filter, setFilter }) => {
  const { t } = useTranslation();
  const { user } = useUserContext();

  return (
    <div className="flex flex-col gap-8 px-12 pt-10">
      <SectionHeading
        title={t("Exams")}
        subtitleClassName="max-w-[560px]"
        subtitle={t(
          "Placeholder copy — Stay ahead of the game with our comprehensive schedule to keep you on track!",
        )}
        cornerComponent={<CornerUser />}
      />

      <div className="flex items-center gap-2">
        <ToggleButton
          label={t("All")}
          isActive={filter === "all"}
          type="secondary"
          onClick={() => setFilter("all")}
        />
        <ToggleButton
          label={t("Enrolled")}
          isActive={filter === "enrolled"}
          type="secondary"
          onClick={() => setFilter("enrolled")}
        />
        <ToggleButton
          label={t("Recent")}
          isActive={filter === "recent"}
          type="secondary"
          onClick={() => setFilter("recent")}
        />
        {!user?.is_successfully_passed_exam && (
          <ToggleButton
            label={t("Upcoming")}
            isActive={filter === "upcoming"}
            type="secondary"
            onClick={() => setFilter("upcoming")}
          />
        )}
      </div>
    </div>
  );
};
